export default __webpack_public_path__ + "images/dbefa281180dfb58f4f11bd23d5c33e5.png";